import { Entity, coreEngine, store } from "@dinahmoe/dmafjs-core";

class UiStrings extends Entity {
  namespace = "se26:uiStrings";

  init(node) {
    super.init(node);

    const data = store.get("assets.data.ui_strings");
    if (!data) return;

    this.createDataNode(node, data);
  }

  createDataNode(node, data) {
    const config = {
      namespace: "se26:uiStringsData",
      uid: "ui_strings"
    };

    for (const [key, value] of Object.entries(data)) {
      config[`strings.${key}`] = value;
    }

    node._dataNode = coreEngine.create(config);
  }
}

const uiStrings = new UiStrings();
export { uiStrings, UiStrings };
